import type { WorkerProfile } from "@/types/workflowEngine";

export const BUILTIN_WORKER_PROFILES: Omit<WorkerProfile, "id" | "userId">[] = [
  {
    name: "Fast & Cheap",
    description: "Low latency, deterministic, cost-efficient for classification tasks.",
    preferredModel: "google/gemini-2.5-flash",
    fallbackModels: ["openai/gpt-4o-mini"],
    temperature: 0.2,
    maxTokens: 2048,
    reasoningMode: false,
    creativity: "low",
    determinism: "high",
    speedTier: "fast",
    budgetPolicy: { maxCreditsPerStep: 1 },
    contextWindowHint: "standard",
    isBuiltin: true,
  },
  {
    name: "Deep Architect",
    description: "Extended reasoning, large context, high quality synthesis.",
    preferredModel: "anthropic/claude-3.5-sonnet",
    fallbackModels: ["openai/gpt-4o"],
    temperature: 0.5,
    maxTokens: 8192,
    reasoningMode: true,
    creativity: "balanced",
    determinism: "balanced",
    speedTier: "quality",
    budgetPolicy: { maxCreditsPerStep: 5 },
    contextWindowHint: "large",
    isBuiltin: true,
  },
  {
    name: "Balanced Default",
    description: "General-purpose balanced profile.",
    preferredModel: "openai/gpt-4o-mini",
    fallbackModels: ["google/gemini-2.5-flash"],
    temperature: 0.7,
    maxTokens: 4096,
    reasoningMode: false,
    creativity: "balanced",
    determinism: "balanced",
    speedTier: "balanced",
    budgetPolicy: {},
    contextWindowHint: "standard",
    isBuiltin: true,
  },
];
